module.exports = __webpack_public_path__ + "static/media/resumeclone.9c10b14b.JPG";